export const calendarStyles = `
  /* React Calendar Base Styles */
  .react-calendar {
    width: 100% !important;
    max-width: 100% !important;
    background: transparent !important;
    border: none !important;
    font-family: inherit !important;
  }
  
  /* Navigation */
  .react-calendar__navigation {
    display: flex !important;
    height: 40px !important;
    margin-bottom: 0.5em !important;
  }
  
  .react-calendar__navigation button {
    min-width: 40px !important;
    background: none !important;
    border: none !important;
    font-size: 16px !important;
    font-weight: bold !important;
    cursor: pointer !important;
    border-radius: 4px !important;
    transition: background-color 0.2s ease !important;
  }
  
  .react-calendar__navigation button:enabled {
    cursor: pointer !important;
  }
  
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #f3f4f6 !important;
    cursor: pointer !important;
  }
  
  .react-calendar__navigation button:disabled {
    opacity: 0.3 !important;
    cursor: not-allowed !important;
  }
  
  /* View Containers */
  .react-calendar__viewContainer {
    background: transparent !important;
    overflow: hidden !important;
  }
  
  .react-calendar__month-view,
  .react-calendar__year-view,
  .react-calendar__decade-view,
  .react-calendar__century-view {
    background: transparent !important;
    min-height: auto !important;
    overflow: hidden !important;
  }
  
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr) !important;
    gap: 4px !important;
    padding-top: 4px !important;
  }
  
  .react-calendar__month-view__weeks {
    display: flex !important;
    flex-direction: column !important;
    max-height: 200px !important;
    overflow: hidden !important;
  }
  
  /* Weekdays Header */
  .react-calendar__month-view__weekdays {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr) !important;
    gap: 4px !important;
    background: transparent !important;
    padding-bottom: 8px !important;
  }
  
  .react-calendar__month-view__weekdays__weekday {
    padding: 8px !important;
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    text-align: center !important;
    color: #6b7280 !important;
  }
  
  /* Tiles (Days/Months/Years) */
  .react-calendar__tile {
    max-width: 100% !important;
    min-height: 38px !important;
    height: 38px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: transparent !important;
    border: none !important;
    font-size: 0.875rem !important;
    position: relative !important;
    cursor: pointer !important;
    border-radius: 4px !important;
    transition: all 0.15s ease-in-out !important;
    box-sizing: border-box !important;
  }

  /* Year/Month/Decade view container - consistent grid */
  .react-calendar__year-view,
  .react-calendar__decade-view,
  .react-calendar__century-view {
    min-height: 240px !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 4px !important;
  }

  .react-calendar__year-view__months,
  .react-calendar__decade-view__years,
  .react-calendar__century-view__decades {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 23px 18px !important;
    padding: 4px !important;
    min-height: auto !important;
  }

  .react-calendar__year-view__months__month,
  .react-calendar__decade-view__years__year,
  .react-calendar__century-view__decades__decade {
    min-height: 38px !important;
    height: 38px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-size: 0.875rem !important;
    padding: 0 !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
  
  .react-calendar__tile:enabled {
    cursor: pointer !important;
  }
  
  /* Hover States */
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    // background-color: #f3f4f6 !important;
    color: #111827 !important;
  }
  
  /* Active/Selected Date - Higher specificity to prevent override */
  .react-calendar__tile--active,
  .react-calendar__tile--active:enabled {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
  }
  
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus,
  .react-calendar__tile--active:hover,
  .react-calendar__tile--active:focus {
    background: #3b82f6 !important;
    color: white !important;
  }
  
  
  /* Disabled Tiles */
  .react-calendar__tile:disabled {
    background-color: transparent !important;
    cursor: not-allowed !important;
    opacity: 0.5 !important;
    color: #9ca3af !important;
  }
  
  /* Selected Year/Month */
  .selected-year-month {
    background-color: #05df72 !important;
    color: white !important;
    font-weight: 600 !important;
    border-radius: 4px !important;
  }
  
  .selected-year-month:hover {
    background-color: #04b862 !important;
    color: white !important;
  }
  
  /* Tomorrow Highlight */
  .tomorrow-highlight:not(:disabled) {
    position: relative !important;
    z-index: 10 !important;
  }
  
  .tomorrow-highlight:not(:disabled)::after {
    content: '' !important;
    position: absolute !important;
    inset: 0px !important;
    border: 1.5px solid rgba(255, 220, 160, 0.9) !important;
    box-shadow: 0 0 24px 6px rgba(255, 160, 80, 0.7), inset 0 0 12px rgba(255, 160, 80, 0.4) !important;
    background-color: transparent !important;
    border-radius: 4px !important;
    pointer-events: none !important;
  }
  
  /* Locked Tiles */
  .locked-tile {
    position: relative !important;
    cursor: not-allowed !important;
    background: transparent !important;
  }
  
  .locked-tile abbr {
    visibility: hidden !important;
  }
  
  .locked-tile .lock-icon {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    display: flex !important;
  }

  /* Locked month tiles in year view - hide default text, show custom content */
  .react-calendar__year-view .locked-tile {
    position: relative !important;
  }

  .react-calendar__year-view .locked-tile abbr {
    visibility: hidden !important;
  }

  .react-calendar__year-view .locked-tile .lock-icon {
    position: static !important;
    transform: none !important;
  }

  /* Center the custom content for locked months */
  .react-calendar__year-view .locked-tile > div {
    position: absolute !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 4px !important;
    color: #374151 !important; /* Dark gray for light mode */
  }
  
  .locked-tile:hover .lock-icon,
  .react-calendar__month-view__days__day--neighboringMonth.locked-tile:hover .lock-icon {
    color: #6b7280 !important;
  }
  
  /* Weekend Days */
  .react-calendar__month-view__days__day--weekend {
    color: #05df72 !important;
  }
  
  /* Neighboring Month Days */
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #d1d5db !important;
  }
  
  .react-calendar__month-view__days__day--neighboringMonth:hover {
    background-color: #f9fafb !important;
    color: #9ca3af !important;
  }
  
  /* DARK THEME STYLES */
  .dark .react-calendar__navigation button {
    color: #f9fafb !important;
  }
  
  .dark .react-calendar__navigation button:enabled:hover,
  .dark .react-calendar__navigation button:enabled:focus {
    background-color: rgba(255, 255, 255, 0.1) !important;
  }
  
  .dark .react-calendar__month-view__weekdays__weekday {
    color: #9ca3af !important;
  }
  
  .dark .react-calendar__tile {
    color: #f9fafb !important;
  }
  
  .dark .react-calendar__tile:enabled:hover,
  .dark .react-calendar__tile:enabled:focus {
    background-color: #343842 !important;
    color: white !important;
  }
  
  /* Dark mode - Active/Selected Date - Higher specificity */
  .dark .react-calendar__tile--active,
  .dark .react-calendar__tile--active:enabled {
    background: #3b82f6 !important;
    color: white !important;
    font-weight: 600 !important;
  }
  
  .dark .react-calendar__tile--active:enabled:hover,
  .dark .react-calendar__tile--active:enabled:focus,
  .dark .react-calendar__tile--active:hover,
  .dark .react-calendar__tile--active:focus {
    background: #3b82f6 !important;
    color: white !important;
  }
  
  .dark .react-calendar__year-view__months .react-calendar__tile:enabled:hover,
  .dark .react-calendar__decade-view__years .react-calendar__tile:enabled:hover,
  .dark .react-calendar__century-view__decades .react-calendar__tile:enabled:hover {
    background-color: #343842 !important;
    color: white !important;
  }
  
  .dark .tomorrow-highlight:not(:disabled)::after {
    border-color: rgba(255, 230, 180, 0.9) !important;
    box-shadow: 0 0 28px 8px rgba(255, 160, 80, 0.6), inset 0 0 12px rgba(255, 160, 80, 0.3) !important;
    background-color: transparent !important;
  }
  
  .dark .react-calendar__tile:disabled {
    color: #6b7280 !important;
    opacity: 0.5 !important;
  }
  
  .dark .locked-tile {
    background: transparent !important;
  }
  
  .dark .locked-tile:hover .lock-icon,
  .dark .react-calendar__month-view__days__day--neighboringMonth.locked-tile:hover .lock-icon {
    color: #9ca3af !important;
  }
  
  .dark .react-calendar__month-view__days__day--weekend {
    color: #f87171 !important;
  }
  
  .dark .react-calendar__month-view__days__day--neighboringMonth {
    color: #4b5563 !important;
  }
  
  .dark .react-calendar__month-view__days__day--neighboringMonth:hover {
    background-color: rgba(255, 255, 255, 0.05) !important;
    color: #6b7280 !important;
  }

  /* Dark mode styling for locked month content */
  .dark .react-calendar__year-view .locked-tile > div {
    color: #f9fafb !important; /* Light text for dark mode */
  }
  
  /* Responsive Adjustments */
  @media (max-width: 640px) {
    .react-calendar {
      font-size: 0.875rem !important;
    }
    
    .react-calendar__tile {
      padding: 0.375rem !important;
      font-size: 0.75rem !important;
    }
    
    .react-calendar__month-view__weekdays__weekday {
      padding: 0.375rem !important;
      font-size: 0.625rem !important;
    }
    
    .react-calendar__navigation button {
      min-width: 36px !important;
      font-size: 14px !important;
    }
  }
  
  /* Focus Styles */
  .react-calendar__tile:focus {
    outline: 2px solid #10b981 !important;
    outline-offset: 2px !important;
  }
  
  .dark .react-calendar__tile:focus {
    outline-color: #10b981 !important;
  }
`;

// Inject styles into document
if (typeof document !== "undefined") {
  const existingStyle = document.getElementById("date-time-picker-styles");
  if (!existingStyle) {
    const styleTag = document.createElement("style");
    styleTag.id = "date-time-picker-styles";
    styleTag.innerHTML = calendarStyles;
    document.head.appendChild(styleTag);
  }
}
